// extracted by mini-css-extract-plugin
export default {"imgdiv":"_45353064b0 e901da04b2","img":"_6a67fe15dc _6a77e2ff2f"};